import variables from 'variables.module.scss';

export const Tabs = {
  cardBg: variables.primaryExtraLightColor,
  itemActiveColor: variables.primaryDarkColor,
  itemColor: variables.primaryDarkColor,
  itemHoverColor: variables.primaryDarkColor,
  itemSelectedColor: variables.primaryDarkColor,
  colorBorderSecondary: variables.primaryDarkColor,
};
